
import {
	FETCH_LOADING,
} from './mutations-type.js'

export default {
  	async fetchLoading ({commit}, res) {
  		commit(FETCH_LOADING, res)
  	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js